/* WNF collection search — 2026-09-04.
 * Shopify owns filtering and card rendering. The text index is a lightweight native-filtered
 * section (250/page); matching cards come from a 24/page native section, at most two requests
 * at a time. No client approximation of metafields, inventory, prices, swatches or variants.
 * Lazy on typed intent. Native browse remains the fallback; incomplete indexes never say zero.
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-wnf-csrch]');
  if (!root || root.dataset.wnfSearchBound) return;
  root.dataset.wnfSearchBound = 'true';
  var input = root.querySelector('[data-wnf-csrch-input]');
  var clear = root.querySelector('[data-wnf-csrch-clear]');
  var base = root.dataset.collectionUrl || '/collections/' + root.dataset.collectionHandle;
  var handle = root.dataset.collectionHandle;
  var original, results, pagination, grid, status, more, cardLayout = [];
  var scope = '', index = null, indexPromise = null, cards = new Map(), cardPages = new Map();
  var controllers = new Set(), indexEpoch = 0, generation = 0, visibleLimit = 24, timer, trackTimer;
  var lastTracked = '', query = '', total = 0;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function canon(s) {
    return String(s || '').toLowerCase().replace(/\blove seats?\b/g, 'loveseat').replace(/\b(sofa beds?|sofabeds?|fold out sofas?)\b/g, 'sleeper sofa')
      .replace(/\bcouches?\b/g, 'sofa').replace(/\bdinning\b/g, 'dining').replace(/\bnight stands?\b/g, 'nightstand')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function scopeParams() {
    var p = new URLSearchParams(location.search), out = new URLSearchParams();
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by' || k === 'preview_theme_id') out.append(k, v); });
    out.sort(); return out;
  }
  function cancel() {
    generation++; indexEpoch++;
    controllers.forEach(function (c) { c.abort(); }); controllers.clear();
    indexPromise = null;
  }
  function connect() {
    var ajax = document.getElementById('CollectionAjaxContent');
    if (!ajax) return false;
    grid = ajax.querySelector('.grid--uniform');
    original = grid && grid.querySelector('.product-grid-container:not([data-wnf-csrch-results])');
    pagination = ajax.querySelector('.pagination, .pagination-custom');
    results = null;
    if (!original) return false;
    var sample = original.querySelector('.grid-product');
    if (sample) cardLayout = Array.from(sample.classList).filter(function (name) { return /^(small--|medium-up--|medium--|large-up--)/.test(name); });
    var count = ajax.querySelector('[data-wnf-grid-count]');
    total = count ? Number(count.dataset.wnfGridCount) : Number(root.dataset.collectionCount);
    original.querySelectorAll('.grid-product[data-product-id]').forEach(function (card) { cards.set(String(card.dataset.productId), card.cloneNode(true)); });
    return true;
  }
  function setCount(n, label) {
    var num = document.querySelector('[data-wnf-count-num]'), txt = document.querySelector('[data-wnf-count-txt]');
    if (num) num.textContent = n;
    if (txt) txt.textContent = label;
  }
  function showNormal() {
    if (results && results.isConnected) results.replaceWith(original);
    results = null;
    if (pagination) pagination.hidden = false;
    if (status) status.remove(); if (more) more.remove();
    setCount(total, 'items');
    root.removeAttribute('aria-busy');
  }
  function resultBox() {
    if (results && results.isConnected) return results;
    results = document.createElement('div');
    results.className = original.className;
    results.dataset.wnfCsrchResults = '';
    original.replaceWith(results); // disconnect native originals to avoid duplicate quick-shop IDs
    if (pagination) pagination.hidden = true;
    return results;
  }
  function progress(message, error) {
    if (status) status.remove(); if (more) more.remove();
    root.setAttribute('aria-busy', error ? 'false' : 'true');
    resultBox().innerHTML = '<div class="wnf-csrch__empty" role="status"><p class="wnf-csrch__empty-head">' + esc(message) + '</p>' +
      (error ? '<p>Your filters are still applied. Try again, or keep shopping this collection.</p><button type="button" class="btn" data-wnf-search-retry>Try again</button> ' : '') +
      '<button type="button" class="wnf-search-clear-link" data-wnf-csrch-clear-inline>Return to the collection</button></div>';
  }
  function fetchSection(name, page, key) {
    var params = new URLSearchParams(key); params.set('section_id', name); params.set('page', page);
    var control = new AbortController(); controllers.add(control);
    var timeout = setTimeout(function () { control.abort(); }, 15000);
    return fetch(base + '?' + params, {signal: control.signal, headers:{Accept:'text/html'}})
      .then(function (r) { if (!r.ok) throw new Error('Section request failed'); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .finally(function () { clearTimeout(timeout); controllers.delete(control); });
  }
  function loadIndex(key) {
    if (index) return Promise.resolve(index);
    if (indexPromise) return indexPromise;
    var all = [], activePromise, epoch = indexEpoch;
    function next(page) {
      return fetchSection('wnf-collection-search-data', page, key).then(function (doc) {
        if (key !== scope || epoch !== indexEpoch) throw new Error('Search changed');
        var element = doc.querySelector('[data-wnf-search-index]');
        if (!element) throw new Error('Search index unavailable');
        var data = JSON.parse(element.textContent);
        if (!Array.isArray(data.products) || !Number.isFinite(data.pages) || !Number.isFinite(data.count)) throw new Error('Invalid search index');
        all = all.concat(data.products);
        if (query.length >= 2) progress('Searching ' + all.length + ' of ' + data.count + ' products…');
        if (page < data.pages) return next(page + 1); // sequential, never a request fanout
        if (all.length !== data.count) throw new Error('The collection changed while searching');
        index = all.map(function (p) { p.text = canon(p.text); p.words = canon(p.title); return p; });
        return index;
      });
    }
    activePromise = next(1).finally(function () { if (indexPromise === activePromise) indexPromise = null; });
    indexPromise = activePromise; return activePromise;
  }
  function matchesFor(q, records) {
    var tokens = canon(q).split(' ').filter(Boolean);
    var vocabulary = new Set(); records.forEach(function (p) { p.text.split(' ').forEach(function (w) { vocabulary.add(w); }); });
    tokens = tokens.map(function (word) {
      if (vocabulary.has(word)) return word;
      if (word.length > 3 && /s$/.test(word) && vocabulary.has(word.slice(0,-1))) return word.slice(0,-1);
      return word;
    });
    // Keep the merchant's selected native sort. Search narrows; it never silently re-sorts price/newness.
    return records.filter(function (p) { return tokens.every(function (token) { return p.text.indexOf(token) !== -1; }); });
  }
  function loadCardPage(page, key) {
    if (cardPages.has(page)) return cardPages.get(page);
    var promise = fetchSection('wnf-collection-search-cards', page, key).then(function (doc) {
      if (scope !== key) throw new Error('Search changed');
      var wrapper = doc.querySelector('[data-wnf-search-cards]');
      if (!wrapper) throw new Error('Product cards unavailable');
      wrapper.querySelectorAll('.grid-product[data-product-id]').forEach(function (card) { cards.set(String(card.dataset.productId), card.cloneNode(true)); });
    }).catch(function (e) { cardPages.delete(page); throw e; });
    cardPages.set(page, promise); return promise;
  }
  function loadCards(matches, key) {
    var pages = Array.from(new Set(matches.filter(function (p) { return !cards.has(String(p.id)); }).map(function (p) { return Math.floor((p.ordinal - 1) / 24) + 1; })));
    var cursor = 0;
    function worker() { if (cursor >= pages.length) return Promise.resolve(); return loadCardPage(pages[cursor++], key).then(worker); }
    return Promise.all([worker(), worker()]); // fixed two-request limit
  }
  function syncURL(q) {
    var url = new URL(location.href);
    if (q) url.searchParams.set('cs', q); else url.searchParams.delete('cs');
    history.replaceState(history.state, '', url);
  }
  function track(q, count) {
    clearTimeout(trackTimer);
    if (q === lastTracked || /@|(?:\d[\s()+.-]*){7,}/.test(q) || new URLSearchParams(location.search).has('preview_theme_id') || (window.Shopify && (Shopify.designMode || Shopify.theme && Shopify.theme.role !== 'main'))) return;
    trackTimer = setTimeout(function () {
      if (input.value.trim() !== q) return;
      lastTracked = q;
      var params = {search_term:q.slice(0,100), collection:handle, results_count:count, no_results:count === 0};
      if (typeof window.gtag === 'function') window.gtag('event', 'collection_search', params);
      else if (window.dataLayer) window.dataLayer.push(Object.assign({event:'collection_search'}, params));
    }, 1200);
  }
  /* wnf-collection-search-fallback-2026-10-08: 39% of collection searches found nothing (mostly other
     categories, e.g. "dresser" on Best Sellers) and only 3.7% used "Search all furniture". Show up to six
     store-wide matches from Shopify predictive search inline; the full-results button stays. */
  function storeMatches(q, turn, key, storeSearch) {
    var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide';
    fetch(url, {headers:{Accept:'application/json'}}).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
      if (!data || turn !== generation || key !== scope) return;
      var box = results && results.querySelector('[data-wnf-csrch-alt]');
      var products = (((data.resources || {}).results || {}).products || []).filter(function (p) { return p && p.url && p.title; });
      if (!box) return;
      var previewing = new URLSearchParams(location.search).has('preview_theme_id') || (window.Shopify && (Shopify.designMode || Shopify.theme && Shopify.theme.role !== 'main'));
      if (!previewing && typeof window.gtag === 'function') window.gtag('event', 'collection_search_fallback', {search_term:q.slice(0,100), collection:handle, results_count:products.length});
      if (!products.length) return;
      var money = function (v) { var n = Number(v); return isFinite(n) && n > 0 ? '$' + n.toLocaleString('en-US', {minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2}) : ''; };
      box.innerHTML = '<p class="wnf-csrch__alt-head">In the rest of the store</p><ul class="wnf-csrch__alt-list">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        return '<li><a href="' + esc(p.url.split('?')[0]) + '" data-wnf-csrch-alt-link>' + (img ? '<img src="' + esc(img) + '" alt="" width="120" height="120" loading="lazy">' : '') +
          '<span class="wnf-csrch__alt-title">' + esc(p.title) + '</span><span class="wnf-csrch__alt-price">' + esc(money(p.price)) + '</span></a></li>';
      }).join('') + '</ul>';
      box.hidden = false;
      var all = box.parentNode.querySelector('a.btn'); if (all) all.textContent = 'See all store results';
    }).catch(function () { /* keep the plain empty state */ });
  }
  function render(q, updateURL, retainLimit) {
    query = q.trim(); clear.hidden = !query;
    var turn = ++generation, key = scope;
    clearTimeout(trackTimer);
    if (updateURL) syncURL(query);
    if (!retainLimit) visibleLimit = 24;
    if (!query) { cancel(); showNormal(); return; }
    if (query.length < 2) { showNormal(); return; }
    if (!index) progress('Finding matches in this collection…');
    loadIndex(key).then(function (records) {
      if (turn !== generation || key !== scope) return;
      var allMatches = matchesFor(query, records), visible = allMatches.slice(0, visibleLimit);
      if (!allMatches.length) {
        if (status) status.remove(); if (more) more.remove();
        root.removeAttribute('aria-busy');
        var storeSearch = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(query) + '&type=product';
        resultBox().innerHTML = '<div class="wnf-csrch__empty" role="status"><h2>No matches for “' + esc(query) + '” in this collection</h2><p>Try fewer words, remove a filter, or look across the store.</p>' +
          '<div class="wnf-csrch__alt" data-wnf-csrch-alt hidden></div>' +
          '<a class="btn" href="' + storeSearch + '">Search all furniture</a> ' +
          '<button type="button" class="wnf-search-clear-link" data-wnf-csrch-clear-inline>Clear this search</button></div>';
        setCount(0, 'matches'); if (updateURL) track(query, 0);
        storeMatches(query, turn, key, storeSearch); return;
      }
      root.setAttribute('aria-busy','true');
      return loadCards(visible, key).then(function () {
        if (turn !== generation || key !== scope) return;
        if (visible.some(function (p) { return !cards.has(String(p.id)); })) throw new Error('Catalog changed; retry search');
        var box = resultBox(); box.replaceChildren();
        visible.forEach(function (p) {
          var card = cards.get(String(p.id)).cloneNode(true);
          if (cardLayout.length) {
            Array.from(card.classList).filter(function (name) { return /^(small--|medium-up--|medium--|large-up--)/.test(name); }).forEach(function (name) { card.classList.remove(name); });
            cardLayout.forEach(function (name) { card.classList.add(name); });
          }
          card.classList.add('aos-animate'); card.querySelectorAll('[data-aos]').forEach(function (el) { el.classList.add('aos-animate'); });
          box.appendChild(card);
        });
        if (more) more.remove(); if (status) status.remove();
        status = document.createElement('p'); status.className = 'wnf-search-status'; status.setAttribute('role','status');
        status.textContent = 'Showing ' + visible.length + ' of ' + allMatches.length + ' matches'; box.after(status);
        if (allMatches.length > visible.length) {
          more = document.createElement('button'); more.type = 'button'; more.className = 'btn wnf-search-more'; more.dataset.wnfSearchMore = '';
          more.textContent = 'Show more matches'; status.after(more);
        }
        root.removeAttribute('aria-busy'); setCount(allMatches.length, allMatches.length === 1 ? 'match' : 'matches');
        if (window.theme && typeof theme.reinitProductGridItem === 'function') theme.reinitProductGridItem();
        if (retainLimit) box.children[Math.min(visibleLimit - 24, visible.length - 1)]?.querySelector('a')?.focus({preventScroll:true});
        if (updateURL) track(query, allMatches.length);
      });
    }).catch(function () { if (turn === generation && key === scope) { progress('Search could not finish', true); setCount('—','matches'); } });
  }
  function clearSearch() { input.value = ''; render('', true); input.focus({preventScroll:true}); }
  input.addEventListener('input', function () { clearTimeout(timer); visibleLimit = 24; clear.hidden = !input.value; timer = setTimeout(function () { render(input.value, true); }, 220); });
  root.addEventListener('submit', function (e) {
    e.preventDefault(); clearTimeout(timer); render(input.value, true);
    if (window.matchMedia && matchMedia('(pointer: coarse)').matches) input.blur(); // dismiss the phone keyboard to reveal results
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); clearSearch(); } });
  clear.addEventListener('click', clearSearch);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wnf-csrch-clear-inline]')) { e.preventDefault(); clearSearch(); }
    if (e.target.closest('[data-wnf-search-retry]')) { e.preventDefault(); index = null; cardPages.clear(); render(input.value, false); }
    if (e.target.closest('[data-wnf-search-more]')) { e.preventDefault(); visibleLimit += 24; render(input.value, false, true); }
  });
  document.addEventListener('collection:reloaded', function () {
    cancel(); var nextScope = scopeParams().toString();
    if (scope !== nextScope) { index = null; cards.clear(); cardPages.clear(); scope = nextScope; }
    if (!connect()) return;
    input.value = new URLSearchParams(location.search).get('cs') || '';
    render(input.value, false);
  });
  // Motion owns popstate/AJAX. This only restores the text field while its grid refresh completes.
  window.addEventListener('popstate', function () { cancel(); input.value = new URLSearchParams(location.search).get('cs') || ''; });
  window.addEventListener('pagehide', cancel);
  scope = scopeParams().toString();
  if (connect()) { input.value = new URLSearchParams(location.search).get('cs') || input.value; if (input.value) render(input.value, false); }
})();
